import React, { Component } from "react";
import getConfig from "next/config";
import html_substring from "html-substring";
import Link from "next/link";
import Feedback from "@containers/Support/Feedback";
import Heading from "@components/Heading";
import ArrowDown from "@components/Icons/ArrowDown";
import FadeoutContainer from "@components/FadeoutContainer";

const {
  publicRuntimeConfig: { settings },
} = getConfig();

const Button = ({ onClick, hidden }) => (
  <button
    onClick={onClick}
    className="flex items-center pt-3 text-secondary outline-none"
  >
    <span className="mr-2 h-20px text-14px -tracking-0.29 underline">
      {hidden ? "Extinde articolul" : "Restrange articolul"}
    </span>
    <span className={`${!hidden ? "rotate-180" : ""}`}>
      <ArrowDown width="9px" height="9px" />
    </span>
  </button>
);

class ArticleCard extends Component {
  state = {
    hidden: true,
  };

  toggleContent = () => {
    this.setState((prevState) => ({
      hidden: !prevState.hidden,
    }));
  };

  render() {
    const { item } = this.props;
    const { hidden } = this.state;

    if (!item) {
      return null;
    }

    const maxLength = 510;
    const showButton =
      item.content.replace(/<[^>]*>?/gm, "").length > maxLength;
    const content =
      hidden && showButton
        ? `${html_substring(item.content, maxLength)}`
        : item.content;

    return (
      <article className="mb-12">
        <Heading title={item.title} as="h2" classesProp="mb-3" />

        <div className="relative">
          <FadeoutContainer
            isFadeVisibile={(showButton && !hidden) || !showButton}
          >
            <div className="Cms">
              <div dangerouslySetInnerHTML={{ __html: content }} />
            </div>
          </FadeoutContainer>

          {((showButton && !hidden) || !showButton) && (
            <>
              {item.tags && (
                <div className="pt-4">
                  <div className="flex flex-wrap -ml-2">
                    {item.tags.map((item) => (
                      <Link
                        key={item.slug}
                        href={`${
                          settings.baseUrl
                        }/suport-clienti/cauta/?ts=${encodeURIComponent(
                          item.title
                        )}`}
                        passHref
                      >
                        <a className="ml-2 mb-2 px-2 py-1 rounded-tr-lg rounded-bl-lg text-13px leading-none -tracking-0.18 bg-newsletterYellow-light">
                          {item.title}
                        </a>
                      </Link>
                    ))}
                  </div>
                </div>
              )}

              <div className="mt-3">
                <Feedback articleSlug={item.slug} />
              </div>
            </>
          )}

          {showButton && (
            <Button onClick={this.toggleContent} hidden={hidden} />
          )}
        </div>
      </article>
    );
  }
}

export default ArticleCard;
